import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import config from "@/lib/config";
import { maskTargetKeys, metaSchemas, userRating } from "@/lib/constants";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";

function recurciveMask() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var copiedData = JSON.parse(JSON.stringify(data));

  function mask(key, value) {
    if (Array.isArray(value)) {
      return value.map(function (v) {
        return mask(key, v);
      });
    } else if (typeof value === "object") {
      return recurciveMask(value);
    } else if (typeof value === "string") {
      if (maskTargetKeys.includes(key)) {
        return value.replace(/./g, "*");
      } else {
        return value;
      }
    }

    return value;
  }

  for (var key in copiedData) {
    var value = copiedData[key];
    copiedData[key] = mask(key, value);
  }

  return copiedData;
}

var LogicaAPI = /*#__PURE__*/function (_RESTDataSource) {
  _inherits(LogicaAPI, _RESTDataSource);

  var _super = _createSuper(LogicaAPI);

  function LogicaAPI(options) {
    var _this;

    _classCallCheck(this, LogicaAPI);

    _this = _super.call(this, options);

    _defineProperty(_assertThisInitialized(_this), "baseURL", config.api.vcmsURL);

    _this.context = options;
    return _this;
  }

  _createClass(LogicaAPI, [{
    key: "config",
    get: function get() {
      var _this$context$req, _this$context$req$use, _this$context$req2, _this$context$req2$us, _this$context$req3, _this$context$req3$us;

      var adultOrVod = this.context.req.adultMode ? "adult" : "vod";
      return {
        service: config.service,
        deviceCode: this.context.req.deviceCode,
        adultMode: this.context.req.adultMode,
        appId: config.appId[adultOrVod],
        storeId: config.storeId[adultOrVod],
        valuePlanId: adultOrVod === "vod" ? config.valuePlanId[adultOrVod] : 0,
        userId: (_this$context$req = this.context.req) === null || _this$context$req === void 0 ? void 0 : (_this$context$req$use = _this$context$req.userToken) === null || _this$context$req$use === void 0 ? void 0 : _this$context$req$use.id,
        profileId: (_this$context$req2 = this.context.req) === null || _this$context$req2 === void 0 ? void 0 : (_this$context$req2$us = _this$context$req2.userToken) === null || _this$context$req2$us === void 0 ? void 0 : _this$context$req2$us.currentProfile,
        rating: (_this$context$req3 = this.context.req) === null || _this$context$req3 === void 0 ? void 0 : (_this$context$req3$us = _this$context$req3.userToken) === null || _this$context$req3$us === void 0 ? void 0 : _this$context$req3$us.rating
      };
    }
  }, {
    key: "dsearchCommonParams",
    get: function get() {
      return {
        service: this.config.service,
        device_code: this.config.deviceCode,
        app_id: this.config.appId,
        datasource: "decorator"
      };
    }
  }, {
    key: "dsearchCommonCondition",
    get: function get() {
      var condition = {
        "values.adult_flag": this.config.adultMode
      };

      if (this.isMaybeLoggedIn() && typeof this.config.rating === "number") {
        condition["values.rating"] = userRating[this.config.rating].permitRating;
      }

      return condition;
    }
  }, {
    key: "dsearchContentTypeCondition",
    value: function dsearchContentTypeCondition(contentType) {
      switch (contentType) {
        case "vod":
          return {
            meta_schema_id: metaSchemas.episode.id,
            "values.is_live": false
          };

        case "catchup":
          return {
            meta_schema_id: metaSchemas.episode.id,
            "values.is_live": true,
            "values.catch_up_flag": true,
            time_range: {
              "values.encode_end_date": {
                lt: "now"
              },
              delivery_end_at: {
                gt: "now"
              }
            }
          };

        case "live":
          return {
            meta_schema_id: metaSchemas.episode.id,
            "values.is_live": true,
            time_range: {
              "values.encode_end_date": {
                gt: "now"
              }
            }
          };

        case "episode":
          return {
            meta_schema_id: metaSchemas.episode.id
          };

        case "channel":
          return {
            meta_schema_id: metaSchemas.channel.id
          };

        case "all":
          return {};
      }
    }
  }, {
    key: "isMaybeLoggedIn",
    value: function isMaybeLoggedIn() {
      var _this$context$req4;

      return !!((_this$context$req4 = this.context.req) !== null && _this$context$req4 !== void 0 && _this$context$req4.userToken);
    }
  }, {
    key: "willSendRequest",
    value: function willSendRequest(_path, request) {
      var _this$context$req5, _this$context$req5$de, _this$context$req6;

      // IPアドレスをforward
      var remoteIp = getRemoteIpAddress(this.context.req);
      request.headers["X-Forwarded-For"] = remoteIp; // UAをプロキシする

      request.headers["User-Agent"] = "".concat((_this$context$req5 = this.context.req) === null || _this$context$req5 === void 0 ? void 0 : (_this$context$req5$de = _this$context$req5.deviceInfo) === null || _this$context$req5$de === void 0 ? void 0 : _this$context$req5$de.ua, " spooxweb");

      if ((_this$context$req6 = this.context.req) !== null && _this$context$req6 !== void 0 && _this$context$req6.userToken) {
        var _this$context$req$use2 = this.context.req.userToken,
            id = _this$context$req$use2.id,
            accessToken = _this$context$req$use2.accessToken;
        request.headers["X-User-Id"] = id;
        request.headers["Authorization"] = "Bearer ".concat(accessToken);

        if (_path === "/api/v1/metas/dsearch" && request.params instanceof URLSearchParams) {
          request.params.append("user_id", id);
        }
      }

      if (_path === "/api/v1/users/existed" || _path === "/api/v1/users/password_update" || _path === "/api/v1/users/regist") {
        request.headers["X-Api-Key"] = config.logica.apikey;
      }

      var requestId = uuidv4();
      request.headers["X-Spoox-Web-Logica-Request-Id"] = requestId;
      var requestParams = request.params || null;
      var userId = request.headers["X-User-Id"];

      try {
        // 個人情報をマスクする
        var maskedBody = recurciveMask(request.body);
        var maskedBodyStr = JSON.stringify(maskedBody || null);
        console.log("[".concat(requestId, "][Logica][REQUEST INFO] Method: ").concat(request.method, ", Path: ").concat(_path, ", Params: ").concat(requestParams, ", UserId: ").concat(userId, ", Body: ").concat(maskedBodyStr));
      } catch (e) {
        // 万が一エラーになってもサービスを止めないようにエラーを潰す
        console.log(e);
      }
    }
  }, {
    key: "didReceiveResponse",
    value: function () {
      var _didReceiveResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, request) {
        var requestId, responseBody, logicaRequestId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestId = request.headers["X-Spoox-Web-Logica-Request-Id"];
                _context.next = 3;
                return _get(_getPrototypeOf(LogicaAPI.prototype), "didReceiveResponse", this).call(this, response, request);

              case 3:
                responseBody = _context.sent;
                logicaRequestId = responseBody === null || responseBody === void 0 ? void 0 : responseBody.request_id;
                console.log("[".concat(requestId, "][Logica][RESPONSE INFO] request_id: ").concat(logicaRequestId, " Status: ").concat(response.status));
                return _context.abrupt("return", responseBody);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function didReceiveResponse(_x, _x2) {
        return _didReceiveResponse.apply(this, arguments);
      }

      return didReceiveResponse;
    }()
  }]);

  return LogicaAPI;
}(RESTDataSource);

export default LogicaAPI;